<template>
  <section>
    <!-- Header -->
    <leftMenu />

    <div id="mainContent" class="point-mirror-content">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">Meus Espelhos Ponto</h1>
        </div>

        <loading-page v-if="loading" />

        <div v-else class="col-xs-12 col-sm-12 col-md-12 offset-top-30">
          <div v-if="dataAlert.length" class="col-xs-12 col-sm-12 col-md-12 default-box box-list-mirror">
            <div class="infos">
              <h2 class="certa">Lista de espelhos</h2>
              <i v-on:click="forceReload()" v-tooltip.top-center="'A última atualização dos dados foi feita no dia ' + this.lastAtt + '. Para atualizar novamente, clique aqui.'" class="fa fa-info-circle info-help" aria-hidden="true"></i>
            </div>

            <div class="table-responsive table-clean">
              <table class="table">
                <thead>
                <tr>
                  <th class="certa">Data</th>
                  <th class="certa">PDF</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(d, key) in dataAlert">
                  <td class="nunito day-info">
                    <svg width="24" height="24" viewBox="0 0 24 24">
                      <path class="a" d="M20,3H19V1H17V3H7V1H5V3H4A2.006,2.006,0,0,0,2,5V21a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3Zm0,18H4V8H20Z"/>
                    </svg>
                    <p class="capitalize">{{d.createdAt | dateDay}} de {{d.createdAt | strMonthFull}} de {{d.createdAt |yearNumber}}, {{d.createdAt |strDayFull}}</p>
                  </td>
                  <td>
                    <ul>
                      <li>
                        <div v-if="loadingGenerateMirror && mirrorKey === key">
                          <div class="loading-btn-table">
                            <div class="spinner-btn-table">
                              <div class="rect1"></div>
                              <div class="rect2"></div>
                              <div class="rect3"></div>
                              <div class="rect4"></div>
                              <div class="rect5"></div>
                            </div>
                          </div>
                        </div>
                        <a v-else v-on:click="generatorWebPdf(d.id, key)" class="pdf-download">
                          <img src="../../../../assets/img/icons/pdf-grey.png" class="img-responsive" alt="PDF">
                          <img src="../../../../assets/img/icons/pdf-white.png" class="img-responsive" alt="PDF">
                          <span class="certa">Abrir</span>
                        </a>
                      </li>
                    </ul>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="!dataAlert.length && failRequest" class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-40 box-empty">
            <img src="../../../..../../../assets/img/empty/internet.png" alt="internet" class="img-fluid img-responsive" />
            <p class="nunito">Tivemos um problema com a conexão, tente novamente atualizando a página.</p>
          </div>

          <div v-if="!dataAlert.length && !failRequest" class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-40 box-empty">
            <img src="../../../..../../../assets/img/empty/comunicados.png" alt="historico" class="img-fluid img-responsive" />
            <p class="nunito">Você ainda não possui nenhum espelho ponto disponível até o momento.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
  import leftMenu from '../../components/leftMenu.vue';
  import loadingPage from '../../components/loadingPage.vue';
  import vueFooter from "../../components/footer";
  import MugenScroll from 'vue-mugen-scroll'

  import { GET_USER_MIRROR, MIRROR_PDF, MIRROR_WEB_PDF_CUSTOM } from "../../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";
  import moment from "moment";

  export default {
    name: 'my-mirror',
    components: {
      leftMenu,
      loadingPage,
      vueFooter,
      MugenScroll
    },
    data() {
      return {
        lastForce: 0,
        lastAtt: null,
        mirrorCtrl: null,
        loading: false,
        loadingMoreItem: false,
        failRequest: false,
        loadingGenerateMirror: false,
        haveMoreMirror: false,
        dataMirror: null,
        dataAlert: [],
        pageQtd: 20,
        pageNumber: 1,
        mirrorKey: null
      }
    },
    methods: {
      getUserMirror() {
        this.loadingGenerateMirror = true;
        this.loadingMoreItem = true;
        this.failRequest = false;

        let url = GET_USER_MIRROR;
        url += "?pageQtd=" + this.pageQtd;
        url += "&pageNumber=" + this.pageNumber;

        UTIL_SERVICE.console("URL:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT GET_USER_MIRROR:", response.data);
          this.mirrorCtrl.dateAtt = moment(new Date()).format('DD/MM/YYYY HH:mm');
          this.mirrorCtrl.dataControl = moment(new Date()).format('DD/MM/YYYY');
          this.mirrorCtrl.pageNumber = this.pageNumber;

          this.dataAlert = [];
          this.mirrorCtrl.data = [];

          this.lastAtt = this.mirrorCtrl.dateAtt;

          if (response.data.list.length) {
            this.haveMoreMirror = response.data.list.length >= 20;
            this.mirrorCtrl.haveMore = this.haveMoreMirror;

            response.data.list.map((value, index) => {
              this.dataAlert.push(value);

              if (response.data.list.length === index + 1) {
                this.mirrorCtrl.data = this.dataAlert;

                UTIL_SERVICE.saveStorage('mirrorCtrl', this.mirrorCtrl);
              }
            });
          } else {
            this.haveMoreMirror = false;
            this.mirrorCtrl.haveMore = false;

            UTIL_SERVICE.saveStorage('mirrorCtrl', this.mirrorCtrl);
          }

          this.loading = false;
          this.loadingMoreItem = false;
        }).catch(reason => {
          UTIL_SERVICE.historyLog(false, window.location.pathname, 'getUserMirror', {}, true, reason.response.data);
          this.failRequest = true;
          this.loading = false;
          this.loadingMoreItem = false;
        });
      },
      generateMirror(id, key) {
        if (id) {
          this.loadingGenerateMirror = true;
          this.mirrorKey = key;
          REQUEST_SERVICE.get(MIRROR_PDF + id).then((response) => {
            UTIL_SERVICE.console("RESULT MIRROR_PDF:", response);

            window.open(response.data, "_blank");
            this.mirrorKey = null;
            this.loadingGenerateMirror = false;
          }).catch(reason => {
            UTIL_SERVICE.historyLog(false, window.location.pathname, 'generateMirror', {id: id}, true, reason.response.data);

            this.mirrorKey = null;
            this.loadingGenerateMirror = false;

            // Show errors.
            reason.response.data.erros.map((value) => {
              swal("Aviso", value.value, "error");
            });
          });
        }
      },
      getMoreItems() {
        if (this.dataAlert.length && this.haveMoreMirror) {
          this.pageNumber++;
          this.loadingMoreItem = true;
          this.getUserMirror();
        }
      },
      generatorWebPdf(id, key) {
        this.loadingGenerateMirror = true;
        this.mirrorKey = key;
        REQUEST_SERVICE.get(MIRROR_WEB_PDF_CUSTOM + id).then((response) => {
          UTIL_SERVICE.console("RESULT MIRROR_WEB_PDF_CUSTOM:", response.data);

          try {
            let value = [response.data];
            window.downloadPdf(value, "Folha de Ponto").then((value) => {
              this.loadingGenerateMirror = false;
              this.mirrorKey = null;
            }).catch(reason => {
              this.generateMirror(id, key);
            });
          } catch (e) {
            this.generateMirror(id, key);
          }
        }).catch(reason => {
          UTIL_SERVICE.historyLog(false, window.location.pathname, 'generatorWebPdf', {id: id}, true, reason.response.data);
          this.mirrorKey = null;
          this.loadingGenerateMirror = false;

          // Show errors.
          reason.response.data.erros.map((value) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      forceReload() {
        let dataNow = new Date().getTime();
        if (dataNow > this.lastForce) {
          this.lastForce = dataNow + 60000;
          this.loading = true;

          this.getUserMirror();
        }
      }
    },
    beforeMount() {
      try {
        this.mirrorCtrl = UTIL_SERVICE.getStorage('mirrorCtrl');

        if (this.mirrorCtrl.dataControl === moment(new Date()).format('DD/MM/YYYY')) {
          UTIL_SERVICE.console('GET DATA FROM STORAGE', this.mirrorCtrl);

          if (this.mirrorCtrl.data) {
            this.dataAlert = this.mirrorCtrl.data;
            this.pageNumber = this.mirrorCtrl.pageNumber;
            this.haveMoreMirror = this.mirrorCtrl.haveMore;
            this.lastAtt = this.mirrorCtrl.dateAtt;
          } else {
            this.loading = true;

            this.getUserMirror();
          }
        } else {
          this.loading = true;

          this.getUserMirror();
        }
      } catch (e) {
        this.loading = true;
        this.mirrorCtrl = {
          dateAtt: null,
          dataControl: null,
          data: null,
          pageNumber: null,
          haveMore: null
        };

        this.getUserMirror();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/views/restricted/myMirror/myMirror.vue